import React from 'react';
import { ShieldCheck, Lock, Clock, Award } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-white py-16 px-4" data-id="element-66">
      <div className="max-w-4xl mx-auto text-center" data-id="element-67">
        <div className="flex justify-center mb-6" data-id="element-68">
          <div className="bg-[#1f2e10] p-4 rounded-full text-[#c4f000]" data-id="element-69">
            <ShieldCheck size={64} data-id="element-70" />
          </div>
        </div>

        <h2 className="text-2xl md:text-3xl font-extrabold text-[#1f2e10] mb-6 uppercase" data-id="element-71">
          7-DAY "HAPPY KID" GUARANTEE
        </h2>

        <p className="text-gray-600 text-lg mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-72">
          Try the Happy Lunchbox system for 7 days. If you don't save time in
          the kitchen, or if your child doesn't love the recipes, just email us
          for a <strong className="text-[#1f2e10]" data-id="element-73">100% refund</strong>. No
          questions asked. The risk is all ours.
        </p>

        <div className="flex flex-wrap justify-center gap-6 md:gap-12" data-id="element-74">
          <div className="flex items-center gap-2 text-sm font-medium text-gray-700" data-id="element-75">
            <Lock className="text-green-600" size={20} data-id="element-76" />
            100% Secure Payment
          </div>
          <div className="flex items-center gap-2 text-sm font-medium text-gray-700" data-id="element-77">
            <Clock className="text-green-600" size={20} data-id="element-78" />
            Instant Access
          </div>
          <div className="flex items-center gap-2 text-sm font-medium text-gray-700" data-id="element-79">
            <Award className="text-green-600" size={20} data-id="element-80" />
            7-Day Guarantee
          </div>
        </div>
      </div>
    </section>;
}